export default "__VITE_ASSET__Cc4HrtXy__"